import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import { Toaster } from "@/components/ui/sonner";

import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Students from "@/pages/Students";
import StudentDetail from "@/pages/StudentDetail";
import Schedule from "@/pages/Schedule";
import Attendance from "@/pages/Attendance";
import Journal from "@/pages/Journal";
import Payments from "@/pages/Payments";
import Documents from "@/pages/Documents";
import WhatsApp from "@/pages/WhatsApp";
import Settings from "@/pages/Settings";
import About from "@/pages/About";
import Profile from "@/pages/Profile";
import ParentPortal from "@/pages/ParentPortal";
import PublicPortal from "@/pages/PublicPortal";
import TodayPublic from "@/pages/TodayPublic";

function AdminRoute({ children }) {
  return (
    <ProtectedRoute role="admin">
      <Layout>{children}</Layout>
    </ProtectedRoute>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/portal/:token" element={<PublicPortal />} />
            <Route path="/jadwal-hari-ini" element={<TodayPublic />} />
            <Route path="/" element={<AdminRoute><Dashboard /></AdminRoute>} />
            <Route path="/siswa" element={<AdminRoute><Students /></AdminRoute>} />
            <Route path="/siswa/:id" element={<AdminRoute><StudentDetail /></AdminRoute>} />
            <Route path="/jadwal" element={<AdminRoute><Schedule /></AdminRoute>} />
            <Route path="/absensi" element={<AdminRoute><Attendance /></AdminRoute>} />
            <Route path="/jurnal" element={<AdminRoute><Journal /></AdminRoute>} />
            <Route path="/pembayaran" element={<AdminRoute><Payments /></AdminRoute>} />
            <Route path="/dokumen" element={<AdminRoute><Documents /></AdminRoute>} />
            <Route path="/whatsapp" element={<AdminRoute><WhatsApp /></AdminRoute>} />
            <Route path="/pengaturan" element={<AdminRoute><Settings /></AdminRoute>} />
            <Route path="/tentang" element={<AdminRoute><About /></AdminRoute>} />
            <Route path="/profil" element={<AdminRoute><Profile /></AdminRoute>} />
            <Route path="/portal" element={<ProtectedRoute role="parent"><ParentPortal /></ProtectedRoute>} />
          </Routes>
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
